import { Modal }  from '../ui/Modal'
import { Button } from '../ui/Button'

interface DeleteConfirmModalProps {
  open:      boolean
  postTitle: string
  onClose:   () => void
  onConfirm: () => void
  loading?:  boolean
}

export function DeleteConfirmModal({
  open, postTitle, onClose, onConfirm, loading,
}: DeleteConfirmModalProps) {
  return (
    <Modal open={open} onClose={onClose} title="Delete Post" maxWidth={440}>
      <p className="dcm-message">
        Are you sure you want to permanently delete{' '}
        <strong>"{postTitle}"</strong>?
        This action cannot be undone.
      </p>
      <div className="dcm-actions">
        <Button variant="ghost" onClick={onClose} disabled={loading}>Cancel</Button>
        <Button variant="danger" onClick={onConfirm} loading={loading}>
          Delete Post
        </Button>
      </div>

      <style>{`
        .dcm-message {
          font-size: 0.9rem;
          color: var(--text-secondary);
          line-height: 1.6;
          margin-bottom: 20px;
        }
        .dcm-message strong { color: var(--text-primary); }
        .dcm-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }
      `}</style>
    </Modal>
  )
}
